import React from "react";
import { IconsBox } from "./components/IconsBox";

function App() {
  return <IconsBox />;
}

export default App;
